module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/france_cn.3d3dad89.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/france_cn.png
// module id = 1072
// module chunks = 16